import { LlmModelName } from 'llm-model-registry';
import { z } from 'zod';

import { BaseFlowBlockSchema, BlockType } from '../base/baseSchema.js';

export const StructuredOutputFieldBaseSchema = z.object({
  fieldLabel: z.string(),
  definition: z.string(),
});

export type StructuredOutputFieldBase = z.infer<typeof StructuredOutputFieldBaseSchema>;

export const MAX_KNOWLEDGE_BASE_FILES = 10;

export const LlmPromptBlockConfigSchema = z.object({
  prompt: z.string().min(1, 'Prompt is required'),
  fileReference: z.string().optional(),
  fileReferences: z.array(z.string()).max(MAX_KNOWLEDGE_BASE_FILES).optional(),
  modelName: z.nativeEnum(LlmModelName, { message: 'Model name is required' }),
  temperature: z
    .number()
    .min(0, 'Temperature must be between 0 and 2')
    .max(2, 'Temperature must be between 0 and 2')
    .optional(),
  maxTokens: z
    .number()
    .int()
    .min(30, 'Max tokens must be greater than 30')
    .max(16384, 'Max tokens must be less than 16384')
    .optional(),
  topP: z
    .number()
    .min(0, 'Top P must be between 0 and 1')
    .max(1, 'Top P must be between 0 and 1')
    .optional(),
  frequencyPenalty: z
    .number()
    .min(-2, 'Frequency penalty must be between -2 and 2')
    .max(2, 'Frequency penalty must be between -2 and 2')
    .optional(),
  responseFormat: z.array(StructuredOutputFieldBaseSchema).optional().default([]),
});

export const LlmPromptBlockBaseSchema = z.object({
  type: z.literal(BlockType.LlmPrompt),
  config: LlmPromptBlockConfigSchema,
});

export const LlmPromptBlockSchema = BaseFlowBlockSchema.merge(LlmPromptBlockBaseSchema);

export type LlmPromptBlock = z.infer<typeof LlmPromptBlockSchema>;
